var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"league-banner",on:{"click":function($event){return _vm.$router.push(("/prematch/sport/" + (_vm.banner.sport) + "/league/" + (_vm.banner.league)))}}},[_c('img',{staticStyle:{"width":"429px"},attrs:{"alt":"#","src":require('@/assets/banners/leagues/320x100-' + _vm.banner.alias + '.jpg')}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be741b3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeagueBanner.vue
// module id = null
// module chunks = 